<template>
  <button
    class="call-to-action"
    :class="`call-to-action--${callToAction.type}`"
    :style="styles"
    @click="(e) => clickLink(e, callToAction.link)"
  >
    <slot name="before"></slot>
    <svg
      v-if="callToAction.type === 'link'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.86918 0.07573C8.65763 0.161024 8.52691 0.389931 8.52691 0.675251C8.52691 0.836557 8.69198 1.05777 9.19899 1.57604L9.87099 2.263L8.32139 3.80727C7.4691 4.65664 6.73277 5.42207 6.6851 5.50832C6.5282 5.79229 6.48014 6.17933 6.56176 6.50114C6.66194 6.8958 7.12469 7.33219 7.52216 7.40677C8.13547 7.52182 8.29649 7.41058 10.0312 5.67272L11.6544 4.04657L12.3803 4.75852C13.105 5.46944 13.2775 5.56021 13.6395 5.42128C13.963 5.2971 14 5.0217 14 2.74089C14 0.429127 13.9737 0.240368 13.6306 0.0839024C13.3965 -0.0228149 9.13189 -0.0301146 8.86918 0.07573ZM1.86014 1.3734C1.15157 1.56454 0.497575 2.13287 0.169507 2.84253C0.00277629 3.2033 0 3.28138 0 7.6525C0 12.0387 0.00222092 12.1005 0.171411 12.4668C0.41413 12.9922 0.934074 13.5237 1.45616 13.7802L1.90368 14H6.34561H10.7875L11.2351 13.7802C11.7579 13.5233 12.278 12.9911 12.5186 12.4668C12.6705 12.1357 12.6919 11.9272 12.717 10.5287L12.7452 8.96167H11.4689H10.1926V10.2312V11.5007H6.34561H2.49858V7.6525V3.80433H3.76771H5.03683V2.53483V1.26533L3.6289 1.27065C2.78303 1.2739 2.07692 1.31492 1.86014 1.3734Z"
        fill="white"
      />
    </svg>
    <span>{{ callToAction.text }}</span>
    <slot name="after"></slot>
  </button>
</template>

<script>
export default {
  emits: {
    clickLink: (link, linkTitle) => {
      const isCorrectLink = typeof link === "string" && link.length > 0;
      const isCorrectLinkTitle =
        typeof linkTitle === "string" && linkTitle.length > 0;

      return isCorrectLink && isCorrectLinkTitle;
    },
  },

  props: {
    callToAction: {
      type: Object,
      require: true,
      validator: (obj) => {
        const importantProps = [
          "backgroundColor",
          "borderColor",
          "borderRadius",
          "borderWidth",
          "link",
          "text",
          "textColor",
          "type",
        ];

        try {
          importantProps.forEach((prop) => {
            const types = ["button", "link"];

            if (!types.includes(obj.type)) {
              throw new Error(`Undefined CallToAction type === '${obj.type}'`);
            }

            if (!Object.keys(obj).includes(prop)) {
              throw new Error(`prop callToAction has no property '${prop}'`);
            }
          });

          return true;
        } catch (e) {
          console.error(e);
          return false;
        }
      },
    },
  },

  computed: {
    styles() {
      return {
        "background-color": this.callToAction.backgroundColor,
        "border-color": this.callToAction.borderColor,
        "border-radius": this.getAdaptiveCssParamFromProp(
          this.callToAction.borderRadius
        ),
        "border-width": this.getAdaptiveCssParamFromProp(
          this.callToAction.borderWidth
        ),
        color: this.callToAction.textColor,
      };
    },
  },

  methods: {
    getAdaptiveCssParamFromProp(prop) {
      return `calc(var(--frisbuy-interaction-width) * ${prop} * 1px)`;
    },

    clickLink(event, link) {
      event.preventDefault();

      // NOTE: protocol need for action.type === "button"
      // the "link" type comes already with the protocol
      // Both types have same meaning, but "link" has SVG
      // Idk why it so
      let protocol = "";
      if (link.slice(0, 4) !== "http") {
        protocol = "https://";
      }

      if (link.length < 1) {
        return;
      }

      window.open(protocol + link, "_blank").focus();

      this.$emit("clickLink", link, this.callToAction.text);
    },
  },
};
</script>

<style lang="scss" scoped>
.call-to-action {
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  gap: calc(var(--frisbuy-interaction-width) * 10 * 1px);

  font-size: calc(var(--frisbuy-interaction-width) * 12 * 1px);

  border-style: solid;
  font-family: Lato, Arial, sans-serif;

  padding: calc(var(--frisbuy-interaction-width) * 10 * 1px)
    calc(var(--frisbuy-interaction-width) * 16 * 1px);

  &:hover {
    scale: 105%;
    transition: scale 0.1s linear;
  }

  svg {
    width: calc(var(--frisbuy-interaction-width) * 14 * 1px);
    aspect-ratio: 1 / 1;
  }
}
</style>
